import React from "react";

const botName = "andresokolbot";
const buttonSize = "large";
const requestAccess = "write";
const usePic = "true";
const lang = "ru";
const widgetVersion = 19;

const scriptProps = {
  "data-telegram-login": botName,
  "data-size": buttonSize,
  "data-request-access": requestAccess,
  "data-userpic": usePic,
  "data-lang": lang,
  "data-onauth": "TelegramLoginWidget.onAuth(user)",
};

const TelegramLoginButton = ({ onAuth }: { onAuth: Function }) => {
  const ref = React.useRef<HTMLDivElement>(null);

  React.useEffect(() => {
    // @ts-ignore
    window.TelegramLoginWidget = {
      onAuth: (user: any) => onAuth(user),
    };

    const script = document.createElement("script");
    script.src = "https://telegram.org/js/telegram-widget.js?" + widgetVersion;
    script.async = true;

    for (let opt in scriptProps) {
      // @ts-ignore
      script.setAttribute(opt, scriptProps[opt]);
    }

    if (ref.current) {
      ref.current?.appendChild(script);
    }

    return () => {
      ref.current?.removeChild(script);
    };
  }, [onAuth]);

  return <div ref={ref}></div>;
};

export default TelegramLoginButton;
